import React, { useState } from 'react';
import CodeBlock from '../components/CodeBlock';

const Examples = () => {


  const examples = {
    javascript: {
      authenticate: `// Authentification avec API Key
const axios = require('axios');

async function authenticateWithApiKey(apiKey) {
  try {
    const response = await axios.post('http://127.0.0.1:8000/api/public/auth', {}, {
      headers: {
        'X-API-Key': apiKey,
        'Content-Type': 'application/json'
      }
    });
    
    const { token, workspaces } = response.data;
    console.log('JWT obtenu:', token);
    console.log('Workspaces:', workspaces);
    
    return token;
  } catch (error) {
    console.error('Erreur:', error.response?.data || error.message);
    throw error;
  }
}

// Utilisation
const apiKey = 'whk_live_votre_cle_api';
const jwt = await authenticateWithApiKey(apiKey);`,
      
      getWorkspaces: `// Récupérer les workspaces
async function getWorkspaces(jwtToken) {
  const response = await axios.get('http://127.0.0.1:8000/api/public/workspaces', {
    headers: {
      'Authorization': \`Bearer \${jwtToken}\`,
      'Content-Type': 'application/json'
    }
  });
  
  return response.data.workspaces;
}

// Exemple d'utilisation
const workspaces = await getWorkspaces(jwt);
console.log('Mes workspaces:', workspaces);`,
      
      sendTemplate: `// Envoyer un message template
async function sendTemplate(jwtToken, workspaceId, payload) {
  const response = await axios.post(
    'http://127.0.0.1:8000/api/v1/messages/send-template',
    payload,
    {
      headers: {
        'Authorization': \`Bearer \${jwtToken}\`,
        'X-Workspace-Id': workspaceId,
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
}

// Exemple : variables positionnelles ({{1}} = Jean, {{2}} = Dupont)
const result = await sendTemplate(jwt, 456, {
  to: '+33612345678',
  templateName: 'welcome_message',
  language: 'fr',
  variables: ['Jean', 'Dupont']
});
console.log('Message envoyé:', result.messageId);`
    },
    php: {
      authenticate: `<?php
// Authentification avec API Key
function authenticateWithApiKey($apiKey) {
    $url = 'http://127.0.0.1:8000/api/public/auth';
    
    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_HTTPHEADER, [
        'X-API-Key: ' . $apiKey,
        'Content-Type: application/json'
    ]);
    
    $response = curl_exec($ch);
    $httpCode = curl_getinfo($ch, CURLINFO_HTTP_CODE);
    curl_close($ch);
    
    if ($httpCode === 200) {
        $data = json_decode($response, true);
        return $data['token'];
    }
    
    throw new Exception('Erreur d\'authentification');
}

// Utilisation
$apiKey = 'whk_live_votre_cle_api';
$jwt = authenticateWithApiKey($apiKey);
?>`,
      
      getWorkspaces: `<?php
// Récupérer les workspaces
function getWorkspaces($jwtToken) {
    $url = 'http://127.0.0.1:8000/api/public/workspaces';
    
    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    curl_setopt($ch, CURLOPT_HTTPHEADER, [
        'Authorization: Bearer ' . $jwtToken,
        'Content-Type: application/json'
    ]);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    return json_decode($response, true);
}

// Exemple d'utilisation
$workspaces = getWorkspaces($jwt);
print_r($workspaces);
?>`,
      
      sendTemplate: `<?php
// Envoyer un message template
function sendTemplate($jwtToken, $workspaceId, $payload) {
    $url = 'http://127.0.0.1:8000/api/v1/messages/send-template';

    $ch = curl_init();
    curl_setopt($ch, CURLOPT_URL, $url);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_HTTPHEADER, [
        'Authorization: Bearer ' . $jwtToken,
        'X-Workspace-Id: ' . $workspaceId,
        'Content-Type: application/json'
    ]);
    curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($payload));
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    return json_decode($response, true);
}

// Exemple
$result = sendTemplate($jwt, 456, [
    'to' => '+33612345678',
    'templateName' => 'welcome_message',
    'language' => 'fr',
    'variables' => ['Jean', 'Dupont']
]);
echo "Message ID: " . $result['messageId'];
?>`
    },
    python: {
      authenticate: `# Authentification avec API Key
import requests

def authenticate_with_api_key(api_key):
    url = 'http://127.0.0.1:8000/api/public/auth'
    
    headers = {
        'X-API-Key': api_key,
        'Content-Type': 'application/json'
    }
    
    response = requests.post(url, headers=headers)
    response.raise_for_status()
    
    data = response.json()
    return data['token']

# Utilisation
api_key = 'whk_live_votre_cle_api'
jwt = authenticate_with_api_key(api_key)
print(f'JWT obtenu: {jwt}')`,
      
      getWorkspaces: `# Récupérer les workspaces
def get_workspaces(jwt_token):
    url = 'http://127.0.0.1:8000/api/public/workspaces'
    
    headers = {
        'Authorization': f'Bearer {jwt_token}',
        'Content-Type': 'application/json'
    }
    
    response = requests.get(url, headers=headers)
    response.raise_for_status()
    
    return response.json()['workspaces']

# Exemple d'utilisation
workspaces = get_workspaces(jwt)
print('Mes workspaces:', workspaces)`,
      
      sendTemplate: `# Envoyer un message template
def send_template(jwt_token, workspace_id, payload):
    url = 'http://127.0.0.1:8000/api/v1/messages/send-template'
    headers = {
        'Authorization': f'Bearer {jwt_token}',
        'X-Workspace-Id': str(workspace_id),
        'Content-Type': 'application/json'
    }
    response = requests.post(url, json=payload, headers=headers)
    response.raise_for_status()
    return response.json()

# Exemple
result = send_template(jwt, 456, {
    'to': '+33612345678',
    'templateName': 'welcome_message',
    'language': 'fr',
    'variables': ['Jean', 'Dupont']
})
print('Message ID:', result['messageId'])`
    },
    curl: {
      authenticate: `# Authentification avec API Key
curl -X POST http://127.0.0.1:8000/api/public/auth \\
  -H "X-API-Key: whk_live_votre_cle_api" \\
  -H "Content-Type: application/json"`,
      
      getWorkspaces: `# Récupérer les workspaces
curl -X GET http://127.0.0.1:8000/api/public/workspaces \\
  -H "Authorization: Bearer VOTRE_JWT_TOKEN" \\
  -H "Content-Type: application/json"`,
      
      sendTemplate: `# Envoyer un message template
curl -X POST http://127.0.0.1:8000/api/v1/messages/send-template \\
  -H "Authorization: Bearer VOTRE_JWT_TOKEN" \\
  -H "X-Workspace-Id: 456" \\
  -H "Content-Type: application/json" \\
  -d '{"to":"+33612345678","templateName":"welcome_message","language":"fr","variables":["Jean","Dupont"]}'`
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1>💻 Exemples d'Intégration</h1>
        <p>
          Exemples de code pratiques pour intégrer l'API WhakUp dans votre application.
          Choisissez votre langage de programmation pour voir les exemples correspondants.
        </p>
      </div>

      <div className="section">
        <h2>1. Authentification</h2>
        <p>Obtenir un JWT avec votre API Key</p>
        <CodeBlock
          languages={[
            { id: 'javascript', name: 'JavaScript', code: examples.javascript.authenticate },
            { id: 'php', name: 'PHP', code: examples.php.authenticate },
            { id: 'python', name: 'Python', code: examples.python.authenticate },
            { id: 'curl', name: 'cURL', code: examples.curl.authenticate }
          ]}
          showCopy={true}
        />
      </div>

      <div className="section">
        <h2>2. Récupérer les Workspaces</h2>
        <p>Liste tous les workspaces accessibles pour votre compte</p>
        <CodeBlock
          languages={[
            { id: 'javascript', name: 'JavaScript', code: examples.javascript.getWorkspaces },
            { id: 'php', name: 'PHP', code: examples.php.getWorkspaces },
            { id: 'python', name: 'Python', code: examples.python.getWorkspaces },
            { id: 'curl', name: 'cURL', code: examples.curl.getWorkspaces }
          ]}
          showCopy={true}
        />
      </div>

      <div className="section">
        <h2>3. Envoyer un message template</h2>
        <p>Envoie un message WhatsApp avec un template (JWT + X-Workspace-Id requis)</p>
        <CodeBlock
          languages={[
            { id: 'javascript', name: 'JavaScript', code: examples.javascript.sendTemplate },
            { id: 'php', name: 'PHP', code: examples.php.sendTemplate },
            { id: 'python', name: 'Python', code: examples.python.sendTemplate },
            { id: 'curl', name: 'cURL', code: examples.curl.sendTemplate }
          ]}
          showCopy={true}
        />
      </div>

      <div className="section">
        <h2>📦 SDK Complet</h2>
        <p>Pour une intégration plus simple, voici un exemple de classe SDK complète :</p>
        
        <CodeBlock
          languages={[
            { 
              id: 'javascript', 
              name: 'JavaScript', 
              code: `class WhakUpAPI {
  constructor(baseURL, apiKey) {
    this.baseURL = baseURL;
    this.apiKey = apiKey;
    this.token = null;
  }

  async authenticate() {
    const response = await axios.post(\`\${this.baseURL}/api/public/auth\`, {}, {
      headers: { 'X-API-Key': this.apiKey }
    });
    this.token = response.data.token;
    return response.data;
  }

  async request(endpoint, method = 'GET', data = null, workspaceId = null) {
    if (!this.token) {
      await this.authenticate();
    }

    const headers = {
      'Authorization': \`Bearer \${this.token}\`,
      'Content-Type': 'application/json'
    };

    if (workspaceId) {
      headers['X-Workspace-Id'] = workspaceId;
    }

    return axios({
      method,
      url: \`\${this.baseURL}\${endpoint}\`,
      headers,
      data
    });
  }

  async getWorkspaces() {
    const response = await this.request('/api/public/workspaces');
    return response.data.workspaces;
  }
}

// Utilisation
const api = new WhakUpAPI('http://127.0.0.1:8000', 'whk_live_...');
const workspaces = await api.getWorkspaces();
console.log('Mes workspaces:', workspaces);`
            },
            {
              id: 'php',
              name: 'PHP',
              code: `class WhakUpAPI {
    private $baseURL;
    private $apiKey;
    private $token;

    public function __construct($baseURL, $apiKey) {
        $this->baseURL = $baseURL;
        $this->apiKey = $apiKey;
    }

    private function authenticate() {
        $response = $this->request('/api/public/auth', 'POST');
        $this->token = $response['token'];
        return $response;
    }

    private function request($endpoint, $method = 'GET', $data = null, $workspaceId = null) {
        if (!$this->token) {
            $this->authenticate();
        }

        $url = $this->baseURL . $endpoint;
        $headers = [
            'Authorization: Bearer ' . $this->token,
            'Content-Type: application/json'
        ];

        if ($workspaceId) {
            $headers[] = 'X-Workspace-Id: ' . $workspaceId;
        }

        $ch = curl_init();
        curl_setopt($ch, CURLOPT_URL, $url);
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
        curl_setopt($ch, CURLOPT_CUSTOMREQUEST, $method);
        curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
        
        if ($data) {
            curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
        }

        $response = curl_exec($ch);
        curl_close($ch);

        return json_decode($response, true);
    }

    public function getWorkspaces() {
        $response = $this->request('/api/public/workspaces');
        return $response['workspaces'];
    }
}

// Utilisation
$api = new WhakUpAPI('http://127.0.0.1:8000', 'whk_live_...');
$workspaces = $api->getWorkspaces();
print_r($workspaces);`
            }
          ]}
          showCopy={true}
        />
      </div>
    </div>
  );
};

export default Examples;
